/* Adapt the unchanged native navigation to translated labels and future menu additions. */
(()=>{
 'use strict';
 const sessions=new Map();
 function mount(){
  for(const [header,cleanup] of sessions)if(!header.isConnected){cleanup();sessions.delete(header);}
  for(const header of document.querySelectorAll('.header--middle-left,.header--middle-center')){
   if(sessions.has(header)||header.classList.contains('drawer-menu'))continue;
   const nav=header.querySelector('.header__inline-menu'),list=nav?.querySelector('.list-menu--inline');
   const drawer=header.querySelector('header-drawer'),logo=header.querySelector('.header__heading-link'),icons=header.querySelector('.header__icons');
   if(!list||!drawer||!logo||!icons)continue;
   const desktop=window.matchMedia('(min-width:990px)'),nativeBreakpoint=drawer.dataset.breakpoint;
   let frame=0,mode='';
   const outerWidth=el=>{const style=getComputedStyle(el);return el.getBoundingClientRect().width+(parseFloat(style.marginLeft)||0)+(parseFloat(style.marginRight)||0);};
   function update(){
    frame=0;
    let overflow=false;
    if(desktop.matches){
     header.classList.add('atelier-nav-ready');
     const style=getComputedStyle(header),padding=(parseFloat(style.paddingLeft)||0)+(parseFloat(style.paddingRight)||0);
     const fixed=outerWidth(logo)+outerWidth(icons)+2*(parseFloat(style.columnGap)||0)+padding;
     const needed=list.getBoundingClientRect().width;
     header.style.setProperty('--atelier-nav-width',Math.ceil(fixed+needed+2)+'px');
     overflow=needed>header.clientWidth-fixed+1;
    }else{
     header.classList.remove('atelier-nav-ready');
     header.style.removeProperty('--atelier-nav-width');
    }
    const next=desktop.matches?(overflow?'drawer':'inline'):'mobile';
    const focusFromNav=next!=='inline'&&mode==='inline'&&nav.contains(document.activeElement);
    if(mode==='inline'&&next!=='inline')for(const item of nav.querySelectorAll('details[open]')){
     item.open=false;item.querySelector('summary')?.setAttribute('aria-expanded','false');
    }
    const details=drawer.querySelector('details'),summary=details?.querySelector('summary');
    const wasOpen=details?.open;
    if(mode&&mode!==next&&wasOpen&&typeof drawer.closeMenuDrawer==='function'){
     drawer.closeMenuDrawer(new Event('resize'),summary);
     if(next==='inline')nav.querySelector('a,summary')?.focus({preventScroll:true});
    }
    header.classList.toggle('atelier-menu-overflow',overflow);
    drawer.dataset.breakpoint=overflow?'desktop':nativeBreakpoint;
    header.dataset.atelierMenuMode=next;
    if(focusFromNav)summary?.focus({preventScroll:true});
    mode=next;
   }
   const schedule=()=>{if(!frame)frame=requestAnimationFrame(update);};
   const sizes=new ResizeObserver(schedule);
   for(const element of [header,logo,icons,list])sizes.observe(element);
   const contents=new MutationObserver(schedule);contents.observe(list,{childList:true,subtree:true,characterData:true});
   window.addEventListener('resize',schedule,{passive:true});
   document.fonts?.addEventListener('loadingdone',schedule);
   document.fonts?.ready.then(schedule);
   sessions.set(header,()=>{sizes.disconnect();contents.disconnect();window.removeEventListener('resize',schedule);document.fonts?.removeEventListener('loadingdone',schedule);if(frame)cancelAnimationFrame(frame);});
   update();
  }
 }
 mount();document.addEventListener('shopify:section:load',mount);
})();
